import script from "./BlogForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogForm.vue?vue&type=script&setup=true&lang=js"

import "./BlogForm.vue?vue&type=style&index=0&id=9c105f3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c105f3c"]])

export default __exports__